export default "__VITE_ASSET__CqMbBWoy__"